<template>
  <div class="leadCenter">
    <div class="title">{{ $t('home.cc') }}</div>
    <el-row>
      <el-col :xs="12" :sm="12" :md="12" :lg="6" :xl="6">
        <div @click="jumpHandler('/waitingProcessing')">
          <img src="@/assets/images/waitingProcessing.png">
          <div class="text">
            <div class="top">{{ $t('home.ntbp') }}</div>
            <div class="bottom"><span class="leadCenterNumber">0</span>{{ langFlag ? '条' : '' }}</div>
          </div>
        </div>
      </el-col>
      <el-col :xs="12" :sm="12" :md="12" :lg="6" :xl="6" v-if="leadData.privateSeaSelfFollow">
        <div @click="jumpHandler('/selfFollow')">
          <img src="@/assets/images/selfFollow.png">
          <div class="text">
            <div class="top">{{ $t('home.nof') }}</div>
            <div class="bottom"><span class="leadCenterSpecial">0</span>{{ langFlag ? '条' : '' }}</div>
          </div>
        </div>
      </el-col>
      <el-col :xs="12" :sm="12" :md="12" :lg="6" :xl="6">
        <div @click="jumpHandler('/clueSuspend')">
          <img src="@/assets/images/suspend.png">
          <div class="text">
            <div class="top">{{ $t('home.nos') }}</div>
            <div class="bottom"><span class="leadCenterNumber">0</span>{{ langFlag ? '条' : '' }}</div>
          </div>
        </div>
      </el-col>
      <el-col :xs="12" :sm="12" :md="12" :lg="6" :xl="6">
        <div @click="jumpHandler('/completedProcessing')">
          <img src="@/assets/images/completedProcessing.png">
          <div class="text">
            <div class="top">{{ $t('home.nop') }}</div>
            <div class="bottom"><span class="leadCenterNumber">0</span>{{ langFlag ? '条' : '' }}</div>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  data() {
    return {
      langFlag: localStorage.getItem('lang') === "zh-CN"
    };
  },
  props: {
    leadData: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  methods: {
    jumpHandler(url) {
      this.$router.push(url);
    },
    numberGrow(targetEle, value = 0) {
      let time = 3000; // 总时间--毫秒为单位
      let finalNum = value; // 要显示的真实数值
      let regulator = 100; // 调速器，改变regulator的数值可以调节数字改变的速度
      let step = finalNum / (time / regulator); /* 每30ms增加的数值-- */
      let count = 0; // 计数器
      let initial = 0;

      let timer = setInterval(function () {
        count = count + step;
        if (count >= finalNum) {
          clearInterval(timer);
          count = finalNum;
        }
        // t未发生改变的话就直接返回

        // 避免调用text函数，提高DOM性能

        var t = Math.floor(count);

        if (t === initial) return;

        initial = t;

        targetEle.innerHTML = initial;
      }, 30);
    },
    numberGrowStart() {
      this.$nextTick(() => {
        let leadCenterEle = document.querySelectorAll('.leadCenter .text>.bottom>.leadCenterNumber');
        this.numberGrow(leadCenterEle[0], this.leadData.privateSeaTodo.total);
        this.numberGrow(leadCenterEle[1], this.leadData.privateSeaHang.total);
        this.numberGrow(leadCenterEle[2], this.leadData.privateSeaDone.total);
        // 自行跟进处理
        if (this.leadData.privateSeaSelfFollow) {
          let SeaSelfFollowEle = document.querySelectorAll('.leadCenter .text>.bottom>.leadCenterSpecial')[0];
          this.numberGrow(SeaSelfFollowEle, this.leadData.privateSeaSelfFollow.total);
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/style/common";

.leadCenter {
  width: 100%;
  background: #FFFFFF;
  padding: 16px;
  margin-top: 16px;

  >.title {
    font-size: 16px;
    font-weight: 600;
    color: #303133;
    margin-top: 10px;
  }

  >.el-row {
    padding: 0 20px;

    >.el-col {
      margin: 10px 0 24px;
      padding-left: 60px;
      cursor: pointer;
      position: relative;

      &~.el-col:before {
        content: "";
        width: 1px;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        background: linear-gradient(0deg, #FFFFFF, #E7EAEF, #FFFFFF);
      }

      >div {
        @extend .clear;

        >img {
          width: 80px;
          float: left;
        }

        >.text {
          float: left;
          margin-left: 30px;

          >.top {
            font-size: 16px;
            color: #5B646E;
            margin-top: 4px;
            font-weight: 400;
          }

          >.bottom {
            height: 52px;
            font-size: 20px;
            line-height: 50px;
            margin-top: 2px;
            overflow: hidden;

            >span {
              font-size: 38px;
              font-weight: bold;
              padding-right: 6px;
            }
          }
        }
      }
    }

    @media screen and (max-width: 1480px) {
      padding: 0 50px;

      >.el-col {
        padding-left: 40px;

        >div {
          >img {
            width: 70px;
          }

          >.text {
            margin-left: 20px;

            >.top {
              font-size: 14px;
            }

            >.bottom {
              line-height: 40px;

              >span {
                font-size: 36px;
              }
            }
          }
        }
      }
    }

    @media screen and (max-width: 1280px) {
      padding: 0 30px;

      >.el-col {
        padding-left: 30px;
      }
    }

    @media screen and (max-width: 1199.5px) {
      >.el-col:nth-of-type(odd):before {
        display: none;
      }
    }
  }
}
</style>
